import React, { useState } from "react";
import { Button, Stack, TextField, Typography } from "@mui/material";
import UserRepository from "../../Repository/UserRepository";
import { toast } from "react-toastify";

function UpdatePassword({ id, onClose, onSuccess }) {
  const [state, setState] = useState({
    old_password: "",
    new_password: "",
    confirmPassword: "",
  });

  const handleInput = (e) => {
    const { value, name } = e.target;
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdate = async () => {
    if (
      state.old_password == "" ||
      state.new_password == "" ||
      state.confirmPassword == ""
    ) {
      toast.configure();
      toast.info("Kindly fill all fields");
      return;
    }
    if (state.new_password != state.confirmPassword) {
      toast.configure();
      toast.info("Your Password is Mismatch");
      return;
    }
    let { data } = await UserRepository.usersModel({
      request: {
        method: "changePassword",
        data: {
          _id: id,
          new_password: state.new_password,
          old_password: state.old_password,
        },
      },
    });
    if (data.response.data.user) {
      toast.configure();
      toast.info("Password Update");
      onClose();
      onSuccess();
    } else if (data.response.status.statusDescription == "Password mismatch!") {
      toast.configure();
      toast.info("Old Password in Invalid");
      onClose();
    } else {
      toast.configure();
      toast.error("Error");
      onClose();
    }
  };

  return (
    <Stack gap={2}>
      <Typography variant="h6" sx={{ color: "#4EAF51" }}>
        Change Your Password
      </Typography>

      <TextField
        autoFocus
        type="password"
        size="small"
        name="old_password"
        label="Old Password"
        value={state.old_password}
        fullWidth
        onChange={handleInput}
      />

      <TextField
        label="New Password"
        size="small"
        name="new_password"
        value={state.new_password}
        type="password"
        fullWidth
        onChange={handleInput}
      />

      <TextField
        size="small"
        label="Confirm Password"
        name="confirmPassword"
        value={state.confirmPassword}
        type="password"
        fullWidth
        onChange={handleInput}
      />

      <Stack direction="row" justifyContent="space-evenly" spacing={4}>
        <Button fullWidth variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button fullWidth variant="contained" onClick={handleUpdate}>
          Save
        </Button>
      </Stack>
    </Stack>
  );
}

export default UpdatePassword;
